import React, {useEffect, useRef, useState} from 'react';
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {themeButtons} from "../../css/themeButtons";
import {Field, Form, Formik} from "formik";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import {Visibility, VisibilityOff} from "@material-ui/icons";
import FormHelperText from "@material-ui/core/FormHelperText";
import {useQuery} from "../common/CustomHook/useQuery";
import * as Yup from "yup";
import {useHistory} from "react-router-dom";


const ChangePassword = (props) => {
    const {changePassword} = props

    const query = useQuery();
    let confirmCode = query.get("changePWCode")

    const [confirmPassChange, setConfirmPassChange] = useState()

    const [showPassword, setShowPassword] = useState(false);
    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const changePassSchema = Yup.object().shape({
        password: Yup.string()
            .min(6, 'Ненадежный пароль')
            .required('Поле не заполнено'),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('password'), null], 'Пароли должны совпадать')
    });


    const history = useHistory()
    const redirectToLogin = () => {
        history.push('/lk/login')
    }

    const [ticks, setTicks] = useState(7);

    useEffect(() => {
        if (confirmPassChange) {
            let timer = setTimeout(() => {
                setTicks(ticks - 1);
            }, 1000);

            return () => clearTimeout(timer);
        }

    }, [ticks, confirmPassChange]);


    useEffect(() => {
        if (confirmPassChange) {
            let timer = null


            timer = setTimeout(() => {
                redirectToLogin()
            }, 7000);


            return () => clearTimeout(timer);
        }

    }, [confirmPassChange]);


    const [formError, setFormError] = useState()

    const formRef = useRef()

    const onSubmit = async values => {
        let response = await changePassword({...values, changePWCode: confirmCode})

        if (response) {
            if (response.status) {
                setConfirmPassChange(true)
            } else {
                setFormError(response.data.message)
            }
        }
    }


    const buttons = themeButtons();
    if (confirmPassChange) {
        return (
            <div className="main ps-0">
                <div className="container-fluid">
                    <div className="w-100 mt-5 text-center">
                        <h5 className="mb-3">Вы успешно сменили пароль!</h5>
                        <Typography className="mb-2" variant="body2" display="block">
                            Нажмите продолжить или подождите и
                            через {ticks} {ticks >= 5 ? "секунд" : ticks > 1 ? "секунды" : "секунду"} мы
                            перенаправим Вас в авторизации
                        </Typography>
                        <Button className={`btn ${buttons.btnGreen}`} onClick={redirectToLogin}
                                variant="contained">Продолжить</Button>

                    </div>
                </div>
            </div>
        )
    }
    return (
        <div className="main ps-0">
            <div className="container-fluid">
                <div className="forgot-password">
                    <div className="login-card mb-4">
                        <Typography variant={"h4"} className={"mb-4"}>Восстановление пароля</Typography>

                        <Formik innerRef={formRef}
                                validationSchema={changePassSchema}

                                initialValues={{password: '', confirmPassword: ''}}
                                onSubmit={onSubmit}>
                            {({errors, touched}) => (
                                <Form>
                                    <div className="row">
                                        <div className="col-12 mb-3">
                                            <Field name="password">
                                                {({field, form}) => (
                                                    <FormControl fullWidth size="small" variant="outlined"
                                                                 error={(errors.password && touched.password) || Boolean(formError)}>
                                                        <InputLabel
                                                            htmlFor="outlined-adornment-password">Новый
                                                            пароль</InputLabel>
                                                        <OutlinedInput
                                                            {...field}
                                                            label={"Новый пароль"}
                                                            type={showPassword ? "text" : "password"}
                                                            endAdornment={
                                                                <InputAdornment position="end">
                                                                    <IconButton
                                                                        aria-label="toggle password visibility"
                                                                        onClick={toggleShowPassword}
                                                                        edge="end"
                                                                    >
                                                                        {showPassword ? <Visibility/> :
                                                                            <VisibilityOff/>}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            }
                                                        />
                                                        {errors.password && touched.password
                                                            ?
                                                            <FormHelperText>{errors.password && touched.password && errors.password}</FormHelperText>
                                                            : null}
                                                    </FormControl>

                                                )}
                                            </Field>
                                        </div>
                                        <div className={`col-12 ${formError ? "mb-2" : "mb-4"}`}>
                                            <Field name="confirmPassword">
                                                {({field, form}) => (
                                                    <FormControl fullWidth size="small" variant="outlined"
                                                                 error={(errors.confirmPassword && touched.confirmPassword) || Boolean(formError)}>
                                                        <InputLabel
                                                            htmlFor="outlined-adornment-password">Подтвердите
                                                            пароль</InputLabel>
                                                        <OutlinedInput
                                                            {...field}
                                                            type={showPassword ? "text" : "password"}
                                                            label="Подтвердите пароль"
                                                            endAdornment={
                                                                <InputAdornment position="end">
                                                                    <IconButton
                                                                        aria-label="toggle password visibility"
                                                                        onClick={toggleShowPassword}
                                                                        edge="end"
                                                                    >
                                                                        {showPassword ? <Visibility/> :
                                                                            <VisibilityOff/>}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            }

                                                        />
                                                        {errors.confirmPassword && touched.confirmPassword
                                                            ?
                                                            <FormHelperText>{errors.confirmPassword && touched.confirmPassword && errors.confirmPassword}</FormHelperText>
                                                            : null}
                                                    </FormControl>

                                                )}
                                            </Field>
                                        </div>
                                    </div>

                                    {formError && <FormHelperText className={"mb-4 px-1"}
                                                                  style={{color: "#f44336"}}>{formError}</FormHelperText>}


                                    <div className="row text-center justify-content-center">
                                        <div className='col-auto mb-2'>

                                            <Button type="submit" className={`${buttons.btnGreen} px-5`}
                                                    variant="contained">Сохранить</Button>

                                        </div>

                                    </div>
                                </Form>
                            )}
                        </Formik>

                    </div>


                </div>
            </div>
        </div>
    );
}

export default ChangePassword;